import { FC } from "react";
import "./dailyRevenueMetrics.css";
import { MoneyBagWithCoinsLined } from "@tag/tag-icons";
import { useForecastContext } from "../../../../context/forecastContext";
import { useTheme } from "../../../../context/themeContext";
import SkeletonLoader from "../../../SkeletonLoader";
import ErrorMessage from "../../../errorMessage/errorMessage";
import dayjs from "dayjs";
import { findForecastForDay } from "../../../../utilities/forecastHelpers";
import { useForecastQuery } from "../../../../services/forecastService";

type DailyRevenueMetricsProps = {};

const DailyRevenueMetrics: FC<DailyRevenueMetricsProps> = () => {
  const { theme } = useTheme();
  const { forecastState } = useForecastContext();

  const {
    data: forecasts,
    isLoading,
    isError,
  } = useForecastQuery({
    mdrSiteId: forecastState.selectedSite?.mdrSiteId!,
    siteId: forecastState.selectedSite?.siteId!,
    orgId: forecastState.selectedSite?.organisationId!,
    searchPeriod: forecastState.searchPeriod,
  });

  if (isLoading) {
    return <SkeletonLoader />;
  }
  if (isError) {
    return <ErrorMessage dataType="Forecast" fontSize="13px" />;
  }

  const forecast = findForecastForDay(
    dayjs(forecastState.selectedDate).format("YYYY-MM-DD"),
    forecasts ?? []
  );

  // if (!forecast) {
  //   return <SkeletonLoader />;
  // }

  if (!forecast) {
    return <>No Data</>;
  }

  return (
    <div className="daily-revenue-metrics-container">
      <div className="daily-revenue-metrics-header">
        <div className="daily-revenue-metrics-header-title">
          <span>
            <MoneyBagWithCoinsLined accent="teal" /> {"Reneue Metrics"}
          </span>
        </div>
      </div>
      <div className="daily-revenue-metrics-content-container"></div>
    </div>
  );
};

export default DailyRevenueMetrics;
